import request from '@/util/request';

//开票接口
export const invoiceIssuePositive = (params, options) =>
  request.post('/api/v4ward/invoice/issuePositive',params, options);

export const sdpInvoiceApply = (params, options) =>
  request.post('/api/v4ward/invoice/sdpIssue',params, options);
